export default __webpack_public_path__ + "static/media/O-035.6ad6ade2.png";